import type { OrgConfig } from '@cult/schemas';
import { create } from 'zustand';

export type { OrgConfig };

const defaultConfig: OrgConfig = {
  orgName: import.meta.env.VITE_ORG_NAME ?? 'CULT BMS',
  orgSlug: import.meta.env.VITE_ORG_SLUG ?? 'cult',
  logoUrl: import.meta.env.VITE_ORG_LOGO ?? '/cult-logo.webp',
  iconUrl: import.meta.env.VITE_ORG_ICON ?? '/android-chrome-192x192.png',
};

type OrgConfigState = {
  config: OrgConfig;
  setConfig: (config: OrgConfig) => void;
};

export const useOrgConfig = create<OrgConfigState>((set) => ({
  config: defaultConfig,
  setConfig: (config) => set((state) => ({ config: { ...state.config, ...config } })),
}));
